(function () {
  var root = document.querySelector('[data-oz-rewards-page]');
  if (!root || root.dataset.ozRewardsReady === 'true') return;
  root.dataset.ozRewardsReady = 'true';

  var summaryUrl = root.getAttribute('data-summary-url') || '/apps/plug-points/summary';
  var redeemUrl = root.getAttribute('data-redeem-url') || '/apps/plug-points/redeem.json';
  var loading = root.querySelector('[data-oz-rewards-loading]');
  var dashboard = root.querySelector('[data-oz-rewards-dashboard]');
  var guest = root.querySelector('[data-oz-rewards-guest]');
  var notice = root.querySelector('[data-oz-rewards-notice]');
  var cardLabel = root.querySelector('[data-oz-rewards-card-label]');
  var balanceEl = root.querySelector('[data-oz-rewards-balance]');
  var cardCaption = root.querySelector('[data-oz-rewards-card-caption]');
  var pointsRate = root.querySelector('[data-oz-points-rate]');
  var levelsEl = root.querySelector('[data-oz-rewards-levels]');
  var couponsEl = root.querySelector('[data-oz-rewards-coupons]');
  var activityEl = root.querySelector('[data-oz-rewards-activity]');
  var pastSection = root.querySelector('[data-oz-rewards-past-section]');
  var pastCouponsEl = root.querySelector('[data-oz-rewards-past-coupons]');
  var heroTitle = root.querySelector('[data-oz-rewards-hero-title]');
  var heroCopy = root.querySelector('[data-oz-rewards-hero-copy]');
  var primaryAction = root.querySelector('[data-oz-rewards-primary-action]');
  var secondaryAction = root.querySelector('[data-oz-rewards-secondary-action]');
  var miniStats = root.querySelector('[data-oz-rewards-mini-stats]');
  var progressWrap = root.querySelector('[data-oz-rewards-progress]');
  var progressTextEl = root.querySelector('[data-oz-rewards-progress-text]');
  var progressPercentEl = root.querySelector('[data-oz-rewards-progress-percent]');
  var progressFill = root.querySelector('[data-oz-rewards-progress-fill]');
  var latestActivity = [];
  var activityExpanded = false;

  function setHidden(el, hidden) {
    if (el) el.hidden = hidden;
  }

  function setText(el, value) {
    if (el) el.textContent = value;
  }

  function setAction(el, href, label, ghost) {
    if (!el) return;
    el.setAttribute('href', href);
    el.textContent = label;
    el.classList.toggle('oz-rewards__button--ghost', Boolean(ghost));
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    return Number.isInteger(amount) ? '$' + amount : '$' + amount.toFixed(2);
  }

  function formatDate(value) {
    if (!value) return 'No expiry date';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'No expiry date';
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function daysLeft(value) {
    if (!value) return 'No expiry date';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'No expiry date';
    var diff = date.getTime() - Date.now();
    if (diff <= 0) return 'Expired';
    var days = Math.ceil(diff / 86400000);
    return days === 1 ? 'Expires tomorrow' : 'Expires in ' + days + ' days';
  }

  function isActiveCoupon(redemption) {
    if (!redemption || redemption.status !== 'issued' || !redemption.code) return false;
    if (!redemption.expiresAt) return true;
    return new Date(redemption.expiresAt).getTime() > Date.now();
  }

  function showNotice(message, isError) {
    if (!notice) return;
    notice.textContent = message || '';
    notice.classList.toggle('is-error', Boolean(isError));
    notice.hidden = !message;
  }

  function copyCode(code, button) {
    if (!code) return;
    var resetText = button ? button.textContent : '';
    var done = function () {
      if (!button) return;
      button.textContent = 'Copied';
      setTimeout(function () {
        button.textContent = resetText || 'Copy code';
      }, 1300);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {
        window.prompt('Copy your reward code:', code);
      });
      return;
    }

    window.prompt('Copy your reward code:', code);
  }

  function miniStatMarkup(type, value, label, attr) {
    return '<div class="oz-rewards__mini-stat oz-rewards__mini-stat--' + escapeHtml(type) + '">' +
      '<span class="oz-rewards__mini-icon" aria-hidden="true"></span>' +
      '<strong' + (attr ? ' ' + attr : '') + '>' + escapeHtml(value) + '</strong>' +
      '<span class="oz-rewards__mini-label">' + escapeHtml(label) + '</span>' +
    '</div>';
  }

  function renderLoggedOut(data) {
    var settings = data && data.settings ? data.settings : {};
    var firstBonus = settings.firstPurchaseBonusPoints || 200;
    var rate = settings.pointsPerDollar || 2;

    setText(heroTitle, 'Earn Plug Points every time you shop.');
    setText(heroCopy, 'Join OZPlug rewards to earn points on eligible paid orders, redeem exclusive discounts, and keep your active coupon codes in one simple place.');
    setAction(primaryAction, '/account/login?return_url=/pages/rewards', 'Log in to rewards', false);
    setAction(secondaryAction, '/collections/all', 'Start shopping', true);

    if (cardLabel) cardLabel.textContent = 'First purchase bonus';
    if (balanceEl) balanceEl.textContent = firstBonus;
    if (cardCaption) cardCaption.textContent = 'bonus Plug Points after your first eligible paid order';
    if (pointsRate) pointsRate.textContent = rate + 'x';
    if (miniStats) {
      miniStats.innerHTML = miniStatMarkup('points', rate + 'x', 'per $1', 'data-oz-points-rate') +
        miniStatMarkup('days', '7', 'coupon days') +
        miniStatMarkup('reward', '$60', 'max reward');
      pointsRate = root.querySelector('[data-oz-points-rate]');
    }
    setHidden(progressWrap, true);
    setHidden(dashboard, true);
    setHidden(guest, false);
    setHidden(loading, true);
    if (data && data.message && data.accessMode !== 'public_login_required' && data.accessMode !== 'login_required') {
      showNotice(data.message, false);
    }
  }

  function renderDashboard(data) {
    var settings = data.settings || {};
    var balance = data.balance || {};
    var points = Number(balance.pointsBalance || 0);
    var rewardName = settings.rewardName || balance.rewardName || 'Plug Points';
    var levels = balance.redemptionLevels || settings.redemptionLevels || [];
    var redemptions = data.redemptions || [];
    var activity = data.activity || [];

    var topLevel = levels.length ? levels[levels.length - 1] : null;
    var nextLevel = levels.find(function (level) { return points < Number(level.points || 0); });
    var progressTarget = nextLevel ? Number(nextLevel.points || 1) : (topLevel ? Number(topLevel.points || 1) : 1);
    var progress = Math.max(0, Math.min(100, Math.round((points / progressTarget) * 100)));
    var progressText = nextLevel ? ((Number(nextLevel.points || 0) - points) + ' points until ' + (nextLevel.label || 'next reward')) : 'All reward levels unlocked';
    var earned = Number(balance.lifetimeEarned || 0);
    var redeemed = Number(balance.lifetimeRedeemed || 0);

    setText(heroTitle, 'Your ' + rewardName + ' dashboard.');
    setText(heroCopy, 'Redeem your points for OZPlug discount codes, track your reward activity, and copy active coupons before checkout.');
    setAction(primaryAction, '#redeem-rewards', 'Redeem rewards', false);
    setAction(secondaryAction, '/collections/all', 'Earn more points', true);

    if (cardLabel) cardLabel.textContent = 'Your balance';
    if (balanceEl) balanceEl.textContent = points.toLocaleString();
    if (cardCaption) cardCaption.textContent = rewardName;
    if (miniStats) {
      miniStats.innerHTML = miniStatMarkup('points', earned.toLocaleString(), 'earned') +
        miniStatMarkup('reward', redeemed.toLocaleString(), 'redeemed') +
        miniStatMarkup('days', '7', 'coupon days');
    }
    if (progressTextEl) progressTextEl.textContent = progressText;
    if (progressPercentEl) progressPercentEl.textContent = progress + '%';
    if (progressFill) progressFill.style.width = progress + '%';
    setHidden(progressWrap, false);

    renderRewardLevels(levels, Boolean(settings.redemptionProcessingEnabled));
    renderCoupons(redemptions);
    renderActivity(activity);
    renderPastCoupons(redemptions);

    setHidden(guest, true);
    setHidden(dashboard, false);
    setHidden(loading, true);
    showNotice(data.accessMode && data.accessMode !== 'public' ? 'Private test preview is active for this account.' : '', false);
  }

  function renderRewardLevels(levels, redemptionEnabled) {
    if (!levelsEl) return;
    if (!levels.length) {
      levelsEl.innerHTML = '<div class="oz-rewards__empty">Reward levels are being prepared.</div>';
      return;
    }

    levelsEl.innerHTML = levels.map(function (level) {
      var available = Boolean(level.available);
      var label = escapeHtml(level.label || formatMoney(level.discountCents));
      var pointsText = escapeHtml(level.points) + ' points';
      var helpText = available ? 'Available now' : ((level.shortfallPoints || level.points) + ' points needed');
      var buttonText = available && redemptionEnabled ? 'Redeem' : (available ? 'Paused' : 'Locked');
      return '<article class="oz-rewards__reward ' + (available ? 'is-available' : 'is-locked') + '">' +
        '<strong>' + label + '</strong>' +
        '<span class="oz-rewards__reward-pill">' + pointsText + '</span>' +
        '<p>' + escapeHtml(helpText) + '</p>' +
        '<button type="button" data-oz-redeem-points="' + escapeHtml(level.points) + '" ' + (!available || !redemptionEnabled ? 'disabled' : '') + '>' + escapeHtml(buttonText) + '</button>' +
      '</article>';
    }).join('');
  }

  function renderCoupons(redemptions) {
    if (!couponsEl) return;
    var active = redemptions.filter(isActiveCoupon).slice(0, 8);
    if (!active.length) {
      couponsEl.innerHTML = '<div class="oz-rewards__empty">No active coupons yet. Redeem available points above to create a 7-day reward code.</div>';
      return;
    }

    couponsEl.innerHTML = active.map(function (item) {
      var code = escapeHtml(item.code || '');
      return '<article class="oz-rewards__coupon">' +
        '<div><strong>' + escapeHtml(item.label) + '</strong>' +
        '<p>' + escapeHtml(daysLeft(item.expiresAt)) + ' • Use by ' + escapeHtml(formatDate(item.expiresAt)) + '</p>' +
        '<code>' + code + '</code></div>' +
        '<button type="button" class="oz-rewards__copy" data-oz-copy-code="' + code + '">Copy code</button>' +
      '</article>';
    }).join('');
  }

  function renderActivity(activity) {
    if (!activityEl) return;
    latestActivity = Array.isArray(activity) ? activity.slice(0, 16) : [];

    if (!latestActivity.length) {
      activityExpanded = false;
      activityEl.innerHTML = '<div class="oz-rewards__empty">No reward activity yet. Place an eligible paid order to start earning Plug Points.</div>';
      return;
    }

    if (latestActivity.length <= 3) activityExpanded = false;

    var visibleActivity = activityExpanded ? latestActivity : latestActivity.slice(0, 3);
    var rows = visibleActivity.map(function (entry) {
      var delta = Number(entry.pointsDelta || 0);
      var positive = delta > 0;
      return '<div class="oz-rewards__activity-row">' +
        '<div><strong>' + escapeHtml(entry.reason || entry.entryType || 'Reward activity') + '</strong>' +
        '<small>' + escapeHtml(formatDate(entry.createdAt)) + ' • Balance after: ' + escapeHtml(entry.balanceAfter) + '</small></div>' +
        '<span class="oz-rewards__delta ' + (positive ? '' : 'is-negative') + '">' + (positive ? '+' : '') + escapeHtml(delta) + '</span>' +
      '</div>';
    }).join('');

    if (latestActivity.length > 3) {
      var remaining = latestActivity.length - 3;
      rows += '<div class="oz-rewards__activity-footer">' +
        '<button type="button" class="oz-rewards__see-all" data-oz-rewards-activity-toggle aria-expanded="' + (activityExpanded ? 'true' : 'false') + '">' +
          (activityExpanded ? 'Show less' : 'See all activity') +
        '</button>' +
        (!activityExpanded ? '<span>' + escapeHtml(remaining) + ' more</span>' : '') +
      '</div>';
    }

    activityEl.innerHTML = rows;
  }

  function renderPastCoupons(redemptions) {
    if (!pastSection || !pastCouponsEl) return;
    var past = redemptions.filter(function (item) {
      return !isActiveCoupon(item) && item.code;
    }).slice(0, 8);

    if (!past.length) {
      setHidden(pastSection, true);
      return;
    }

    pastCouponsEl.innerHTML = past.map(function (item) {
      return '<div class="oz-rewards__activity-row">' +
        '<div><strong>' + escapeHtml(item.label) + '</strong>' +
        '<small>' + escapeHtml(item.status) + ' • ' + escapeHtml(item.code) + '</small></div>' +
        '<span>' + escapeHtml(formatDate(item.updatedAt || item.createdAt)) + '</span>' +
      '</div>';
    }).join('');
    setHidden(pastSection, false);
  }

  function refreshSummary() {
    return fetch(summaryUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data || data.ok !== true || !data.loggedIn || !data.accessAllowed) {
          renderLoggedOut(data || {});
          return data;
        }
        renderDashboard(data);
        return data;
      })
      .catch(function () {
        setHidden(loading, true);
        setHidden(dashboard, true);
        setHidden(guest, false);
        showNotice('Rewards are temporarily unavailable. Please refresh or try again shortly.', true);
      });
  }

  function redeem(points, button) {
    if (!points || button.disabled) return;
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Creating code…';
    showNotice('', false);

    var idempotencyKey = 'pages-rewards-' + Date.now() + '-' + Math.random().toString(16).slice(2);

    fetch(redeemUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ points: Number(points), idempotency_key: idempotencyKey })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || !data || data.ok !== true) {
            var message = data && data.error && data.error.message ? data.error.message : 'Reward could not be redeemed. Please refresh and try again.';
            throw new Error(message);
          }
          return data;
        });
      })
      .then(function (data) {
        showNotice(data.message || 'Reward code created successfully. Copy it from Active coupons.', false);
        if (data.balance && data.redemptions) {
          renderDashboard({
            ok: true,
            loggedIn: true,
            accessAllowed: true,
            accessMode: 'public',
            settings: data.settings || {},
            balance: data.balance,
            redemptions: data.redemptions || [],
            activity: data.activity || []
          });
        } else {
          refreshSummary();
        }
        if (data.redemption && data.redemption.code) {
          copyCode(data.redemption.code);
        }
      })
      .catch(function (error) {
        showNotice(error.message || 'Reward could not be redeemed. Please refresh and try again.', true);
      })
      .finally(function () {
        button.textContent = original || 'Redeem now';
        refreshSummary();
      });
  }

  root.addEventListener('click', function (event) {
    var activityToggle = event.target.closest('[data-oz-rewards-activity-toggle]');
    if (activityToggle) {
      activityExpanded = !activityExpanded;
      renderActivity(latestActivity);
      return;
    }

    var copyButton = event.target.closest('[data-oz-copy-code]');
    if (copyButton) {
      copyCode(copyButton.getAttribute('data-oz-copy-code'), copyButton);
      return;
    }

    var redeemButton = event.target.closest('[data-oz-redeem-points]');
    if (redeemButton) {
      redeem(redeemButton.getAttribute('data-oz-redeem-points'), redeemButton);
    }
  });

  refreshSummary();
})();
